import { render, staticRenderFns } from "./GeneralMessage.vue?vue&type=template&id=2c44777f&"
import script from "./GeneralMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports